import $dom from 'cash-dom';

const FORM_ATTR = 'data-account-form';
const FORM_SWITCH_ATTR = 'data-account-form-switch';

export default () => {
  const $forms = $dom(`[${FORM_ATTR}]`);
  const $formSwitches = $dom(`[${FORM_SWITCH_ATTR}]`);

  if ($forms.length === 0) {
    return false;
  }

  const toggleForms = formId => {
    $forms.each((i, elem) => {
      if (elem.getAttribute(FORM_ATTR) === formId) {
        $dom(elem).removeClass('is-hidden');
      } else {
        $dom(elem).addClass('is-hidden');
      }
    });
  };

  const { location } = window;

  if (location.hash && location.hash === '#recover') {
    toggleForms('recover-password');
  }

  $formSwitches.on('click', e => {
    const $elem = $dom(e.target);

    toggleForms($elem.attr(FORM_SWITCH_ATTR));
  });
};
